import PropTypes from 'prop-types';
import { Col } from 'reactstrap';

import React from 'react';
import type { ReactNode } from 'react';

const GridCol = ({
  children,
  className,
  xs,
}: {
  children: ReactNode;
  className: string;
  xs: number;
}) => (
  <Col
    className={`d-flex justify-content-center text-center text-nowrap articleQuantityGrid align-items-center ${className}`}
    xs={xs}
  >
    {children}
  </Col>
);

GridCol.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  xs: PropTypes.number,
};

GridCol.defaultProps = {
  className: '',
  xs: 4,
};

export default GridCol;
